module.exports = __webpack_public_path__ + "media/images/john-planting-2-e1dbd02c5f8c8bf33116353f855131d1.png";